import { render, staticRenderFns } from "./DialogChooseTag.vue?vue&type=template&id=6a7fb093"
import script from "./DialogChooseTag.vue?vue&type=script&lang=js"
export * from "./DialogChooseTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports